import { React, useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../styles/dashboard.css";

const DashboardComponent = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showServiceMenu, setShowServiceMenu] = useState(false);
  const [showNav, setShowNav] = useState(true);

  //項目功能輪播參數
  const [index, setIndex] = useState(0);

  const [customerIndex, setCustomerIndex] = useState(0);

  useScrollDirection(setShowNav, 50); // 只有滾動超過 50px 才改變狀態

  //偵測設備螢幕寬度
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //處理登入/登出系統
  const handleLogin = () => {
    window.alert("登入功能開發中！盡請期待！");
  };

  //偵測螢幕滾動顯示上方導覽列
  function useScrollDirection(setVisible, threshold = 30) {
    const lastScrollTop = useRef(0);
    const lastTriggerTop = useRef(0); // 上次觸發時的位置

    useEffect(() => {
      const handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const delta = scrollTop - lastTriggerTop.current;

        if (Math.abs(delta) > threshold) {
          if (delta > 0) {
            setVisible(false); // 向下滾超過 threshold，隱藏
            setShowServiceMenu(false);
          } else {
            setVisible(true); // 向上滾超過 threshold，顯示
          }
          lastTriggerTop.current = scrollTop; // 更新觸發點
        }

        lastScrollTop.current = scrollTop <= 0 ? 0 : scrollTop;
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, [setVisible, threshold]);
  }

  //服務項目功能輪播資料
  const serviceCarouselData = [
    {
      image: "/images/yunko/ic-flow-year.png",
      title: "流年運勢詳批",
      subtitle: "掌握今年的起伏與轉機",
      description:
        "每一年都有其專屬的能量，流年正是命理中反映該年運勢的鏡子。如果你感覺今年「特別卡」或想知道「何時轉運」，流年詳批就是你的年度導航。",
    },
    {
      image: "/images/yunko/ic-big-flow.png",
      title: "十年大運詳批",
      subtitle: "人生關鍵十年的命理導航",
      description:
        "大運為命盤中最重要的流動力量，每10年轉換一次，影響層面深遠。這份大運分析，適合在人生轉折處做為「長期規劃」的重要參考。",
    },
    {
      image: "/images/yunko/ic-love-report.png",
      title: "真愛合盤",
      subtitle: "你們真的合嗎？從命盤看愛情契合度",
      description:
        "八字不只能看自己，更能看你與另一半之間的相處頻率與愛情緣分，適合：交往中／考慮同居或結婚的情侶，曖昧中的對象也可以參考。",
    },
    {
      image: "/images/yunko/ic-friends-report.png",
      title: "友情合盤",
      subtitle: "你們真的合拍嗎？讓命盤來說話！",
      description:
        "朋友之間也有命理相合與不合之處，分析雙方命格的互動關係，適合：閨蜜、兄弟、同事、合作夥伴、團隊分析。",
    },
    {
      image: "/images/yunko/ic-name-report.png",
      title: "姓名分析測算",
      subtitle: "你的名字藏著什麼樣的能量密碼",
      description:
        "姓名影響一個人的氣場與對外表現，甚至影響命運與健康。適合命盤不順者或想轉運者參考的姓名分析建議。",
    },
    {
      image: "/images/yunko/ic-trigrams.png",
      title: "奇門遁甲",
      subtitle: "轉動氣場，創造好運流動",
      description:
        "奇門遁甲是古代帝王御用的風水術數，讓你也能掌握轉運的主動權。適合想提升運勢、轉換能量場、或正值低潮、覺得怎麼做都不順的朋友。",
    },
  ];
  //服務項目功能輪播
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % serviceCarouselData.length);
      }, 600); // 與動畫時間一致
    }, 3000);

    return () => clearInterval(timer);
  }, []);
  //目前輪播到的服務項目
  const current = serviceCarouselData[index];

  //用戶反饋輪播資料
  const customerFeedbackData = [
    {
      customer: "台北 王OO 34歲",
      feedback:
        "「以前看命理都覺得太玄，這次的八字解析真的讓我重新認識自己，很多困惑突然就通了！」",
    },
    {
      customer: "新北 宋OO 28歲",
      feedback:
        "「命理老師不是只講命，而是會給你實際的建議，真的覺得不是迷信，是一種生活導航。」",
    },
    {
      customer: "彰化 林OO 31歲",
      feedback:
        "合盤分析後才發現，原來我們的溝通問題早就寫在命盤裡，老師給的方法很實用，現在相處順很多。」",
    },
    {
      customer: "台中 陳OO 29歲",
      feedback:
        "「今年一直很不順，看到流年詳批後才明白這是低運年，至少我知道該沉潛、不要硬衝，反而比較心安。」",
    },
    {
      customer: "台北 林OO 26歲",
      feedback:
        "「我其實很怕被嚇，但老師完全不會用恐嚇式的說法，整份報告像是有溫度的解說，讓我安心很多。」",
    },
    {
      customer: "台北 張OO 31歲",
      feedback:
        "「我朋友推薦我做了姓名分析，改名字沒那麼簡單，但至少我知道現在這個名字會帶來什麼樣的能量，很值得。」",
    },
    {
      customer: "高雄 陳OO 30歲",
      feedback:
        "「原本只是好奇奇門遁甲，結果老師幫我改了一下辦公桌方向，真的人變清爽、工作效率也提升了不少！」",
    },
    {
      customer: "新竹 孫OO 26歲",
      feedback:
        "「這是我第三次做命理測算，整個流程很順，文案也看得懂，不會像以前那樣艱深難懂，根本搞不清楚在看什麼。」",
    },
    {
      customer: "台北 李OO 28歲",
      feedback:
        "「我媽媽一直不信，但看到我拿到的命盤報告，她竟然說：『這個很準，你在哪裡測的？我也要一份』！」",
    },
    {
      customer: "高雄 吳OO 31歲",
      feedback:
        "「原本覺得命理報告只是看看，但這份八字詳解我一直留著，每次遇到人生選擇都會翻出來重新看看，真的有幫助。」",
    },
  ];
  //用戶反饋輪播排程
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeout(() => {
        setCustomerIndex((prev) => (prev + 1) % customerFeedbackData.length);
      }, 200); // 與動畫時間一致
    }, 2000);

    return () => clearInterval(timer);
  }, []);
  //目前輪播到的服務項目
  const currentCustomer = customerFeedbackData[customerIndex];

  //移動裝置參數
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="main">
      {/* 電腦板佈局 */}
      {!isMobile && (
        <div className="dashboard">
          <nav className={` ${showNav ? "show" : "hide"}`}>
            <div className="main-nav">
              <div className="logo">
                <img
                  src={`/images/yunko/ic-yunko-logo.png`}
                  loading="lazy"
                  alt="元辰雲閣"
                />
              </div>

              {/* 上方選單功能 */}
              <div className="nav-list">
                {showServiceMenu && (
                  <div className="fortune-service">
                    <div className="item-service">
                      <Link className="nav-link" to="/flow-year">
                        <img
                          src={`/images/yunko/ic-flow-year.png`}
                          loading="lazy"
                          alt="流年運勢詳批"
                        />
                        <p>流年運勢詳批</p>
                      </Link>
                    </div>

                    <div className="item-service">
                      <Link className="nav-link" to="/big-flow">
                        <img
                          src={`/images/yunko/ic-big-flow.png`}
                          loading="lazy"
                          alt="十年大運詳批"
                        />
                        <p>十年大運詳批</p>
                      </Link>
                    </div>

                    <div className="item-service">
                      <Link className="nav-link" to="/love-report">
                        <img
                          src={`/images/yunko/ic-love-report.png`}
                          loading="lazy"
                          alt="真愛合盤"
                        />
                        <p>真愛合盤</p>
                      </Link>
                    </div>

                    <div className="item-service">
                      <Link className="nav-link" to="/friend-report">
                        <img
                          src={`/images/yunko/ic-friends-report.png`}
                          loading="lazy"
                          alt="友情合盤"
                        />
                        <p>友情合盤</p>
                      </Link>
                    </div>

                    <div className="item-service">
                      <Link className="nav-link" to="/name-report">
                        <img
                          src={`/images/yunko/ic-name-report.png`}
                          loading="lazy"
                          alt="姓名分析測算"
                        />
                        <p>姓名分析測算</p>
                      </Link>
                    </div>

                    <div className="item-service">
                      <Link className="nav-link" to="/trigrams">
                        <img
                          src={`/images/yunko/ic-trigrams.png`}
                          loading="lazy"
                          alt="奇門遁甲"
                        />
                        <p>奇門遁甲</p>
                      </Link>
                    </div>
                  </div>
                )}

                <ul>
                  <li
                    className="nav-item"
                    onMouseEnter={() => setShowServiceMenu(false)}
                  >
                    <Link className="nav-link" to="/story">
                      品牌故事
                    </Link>
                  </li>

                  <li
                    className="nav-item"
                    onMouseEnter={() => setShowServiceMenu(false)}
                  >
                    <Link className="nav-link" to="/personal-chart">
                      個人專屬命盤
                    </Link>
                  </li>

                  <li
                    className="nav-item service"
                    onMouseEnter={() => setShowServiceMenu(true)}
                  >
                    命理服務
                    {showServiceMenu && <div class="triangle"></div>}
                  </li>

                  <li
                    className="nav-item"
                    onMouseEnter={() => setShowServiceMenu(false)}
                  >
                    <Link className="nav-link" to="/blog">
                      雲閣藏書
                    </Link>
                  </li>
                  <li
                    className="nav-item"
                    onMouseEnter={() => setShowServiceMenu(false)}
                  >
                    <Link className="nav-link" to="/store">
                      雲上雜貨店
                    </Link>
                  </li>

                  <li
                    className="nav-item"
                    onMouseEnter={() => setShowServiceMenu(false)}
                  >
                    <Link className="nav-link" to="/teacher">
                      大師諮詢
                    </Link>
                  </li>
                </ul>
                <button
                  onClick={handleLogin}
                  onMouseEnter={() => setShowServiceMenu(false)}
                >
                  登入
                </button>
              </div>
            </div>
          </nav>
          {/* 用現代思維看懂命運 */}
          <div
            className="first-block"
            onMouseEnter={() => setShowServiceMenu(false)}
          >
            <div className="inner">
              <div className="display-figure">
                <div className="back-card"></div>

                <img
                  src={`/images/yunko/bg-figure-1.jpg`}
                  loading="lazy"
                  alt="用現代思維看懂命運的規律"
                />
              </div>

              <div className="space"></div>

              <div className="first-des">
                <p className="slogan">
                  用現代思維，<br></br>看懂命運的規律。
                </p>

                <div className="horz-line"></div>

                <p className="sub-slogan">
                  結合千年命理經典與現代生活語言，給你最貼近人生的解析
                </p>

                <button>查看命理服務項目</button>
              </div>
            </div>
          </div>
          {/* 命理應該被說得更清楚 */}
          <div
            className="second-block"
            onMouseEnter={() => setShowServiceMenu(false)}
          >
            <div className="outer">
              <div className="inner">
                <div className="second-des">
                  <p className="slogan">
                    命理應該被說得<br></br>更清楚、更貼近生活
                  </p>

                  <div className="sub-slogan">
                    <div className="v-line"></div>
                    <p>
                      我的命理解析講人話，不講艱深術語<br></br>
                      內容落實在感情、職涯、健康、財運各方面<br></br>
                      一步一腳印，從你的命盤給出實際建議
                    </p>
                  </div>
                </div>

                <div className="figure-img">
                  <img
                    src={`/images/yunko/bg-figure-2.jpg`}
                    loading="lazy"
                    alt="命理應該被說得更清楚"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* 傳統與我們的差異 */}
          <div
            className="third-block"
            onMouseEnter={() => setShowServiceMenu(false)}
          >
            <p className="slogan">不只是看命，而是讓你掌握命運的節奏。</p>

            <p className="sub-slogan">
              為什麼選擇我們？與傳統命理網站有什麼不同？
            </p>

            <div className="inner">
              <div className="normal">
                <p className="title">傳統命理網站</p>
                <p className="sub-title">使用難懂術語堆疊</p>
                <p className="sub-title">制式分析套模</p>
                <p className="sub-title">命理方式各自分開</p>
              </div>

              <div className="our">
                <div className="our-inner">
                  <p className="title">我們的方式</p>

                  <div className="sub-title">
                    <p className="des">白話命盤解說</p>
                    <img
                      src={`/images/yunko/ic-victory.png`}
                      loading="lazy"
                      alt="勝"
                    />
                  </div>

                  <div className="sub-title">
                    <p className="des">一對一解析與命格差異考量</p>
                    <img
                      src={`/images/yunko/ic-victory.png`}
                      loading="lazy"
                      alt="勝"
                    />
                  </div>

                  <div className="sub-title">
                    <p className="des">結合八字與紫微斗數測算</p>
                    <img
                      src={`/images/yunko/ic-victory.png`}
                      loading="lazy"
                      alt="勝"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 個人專屬命盤 */}
          <div
            className="forth-block"
            onMouseEnter={() => setShowServiceMenu(false)}
          >
            <div className="inner">
              <div className="display-figure">
                <div className="back-card"></div>

                <img
                  src={`/images/yunko/bg-figure-3.jpg`}
                  loading="lazy"
                  alt="用現代思維看懂命運的規律"
                />
              </div>

              <div className="space"></div>

              <div className="forth-des">
                <p className="slogan">個人專屬命盤</p>

                <p className="small-slogan">從八字與紫薇中看見真實的你</p>

                <p className="des">
                  你的出生年、月、日、時，蘊藏了獨一無二的命格結構。這是一份了解自己、理解命運節奏的第一步，也最值得收藏的專屬命理藍圖。
                </p>

                <button>免費測算命盤</button>
              </div>
            </div>
          </div>
          {/* 所有功能輪播介紹 */}
          <div
            className="fifth-block"
            onMouseEnter={() => setShowServiceMenu(false)}
          >
            <img src={current.image} alt={current.title} loading="lazy" />
            <p className="title">{current.title}</p>
            <p className="small-title">{current.subtitle}</p>
            <p className="sub-title">{current.description}</p>

            <div className="process-bar">
              {serviceCarouselData.map((_, i) => (
                <div
                  key={i}
                  className={`bar-segment ${i === index ? "active" : ""}`}
                />
              ))}
            </div>
            <button>查看更多</button>
          </div>
          {/* 用戶回饋輪播 */}
          <div
            className="sixth-block"
            onMouseEnter={() => setShowServiceMenu(false)}
          >
            <div className="inner">
              <div className="sixth-des">
                <p className="slogan">
                  數萬人親身體驗，<br></br>命理也可以很清楚！
                </p>

                <p className="customer">{currentCustomer.customer}</p>
                <p className="feedback">{currentCustomer.feedback}</p>

                <div className="process-bar">
                  {customerFeedbackData.map((_, i) => (
                    <div
                      key={i}
                      className={`bar-segment ${
                        i === customerIndex ? "active" : ""
                      }`}
                    />
                  ))}
                </div>
              </div>

              <div className="space"></div>

              <div className="figure-img">
                <img
                  src={`/images/yunko/bg-figure-4.jpg`}
                  loading="lazy"
                  alt="圖片 1"
                />
              </div>
            </div>
          </div>
          {/* 引導獲取專屬命盤 */}
          <div
            className="seventh-block"
            onMouseEnter={() => setShowServiceMenu(false)}
          >
            <p className="title">你的命格藏著什麼樣的關鍵密碼？</p>
            <p className="sub-title">
              輸入生日時間，免費取得你的專屬命盤解析報告
            </p>
          </div>
          {/*元辰雲閣理念*/}
          <div
            className="eighth-block"
            onMouseEnter={() => setShowServiceMenu(false)}
          >
            <div className="outer">
              <div className="inner">
                <div className="display-figure">
                  <div className="back-card"></div>

                  <img
                    src={`/images/yunko/bg-figure-5.jpg`}
                    loading="lazy"
                    alt="用現代思維看懂命運的規律"
                  />
                </div>

                <div className="space"></div>

                <div className="eighth-des">
                  <p className="title">元辰雲閣的理念</p>

                  <div className="slogan">
                    <div className="v-line"></div>

                    <div className="slogan-des">
                      <p className="main-slogan">
                        「命理不是命運的答案，而是未來人生的提案！」
                      </p>

                      <p className="main-des">
                        元辰雲閣由多年經驗的命理師創立，堅持以誠信、專業與平實價格，提供真正對人生有幫助的命理服務。我們深知傳統命理博大精深，但更相信，命理不該艱澀難懂，而是每個人都能看得懂、用得上的生活智慧。
                      </p>

                      <p className="extra-des">
                        我們的責任，是用現代語言解釋命盤中的訊息，幫你看懂自己的節奏與方向，安心走好每一步人生路。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*隱私政策與聯絡官方*/}
          <footer>
            <div
              className="inner"
              onMouseEnter={() => setShowServiceMenu(false)}
            >
              <div className="logo">
                <img
                  src={`/images/yunko/ic-yunko-logo.png`}
                  loading="lazy"
                  alt="元辰雲閣"
                />
              </div>
              <div className="other-info">
                <a href="">隱私權政策與使用條款</a>

                <a href="">聯絡官方Line客服</a>

                <p>Copyright © 2025 元辰雲閣</p>
              </div>
            </div>
          </footer>
        </div>
      )}

      {/* 移動裝置佈局 */}
      {isMobile && (
        <div className="mobile-dashboard">
          <nav className={` ${showNav ? "show" : "hide"}`}>
            <img
              className="menu"
              src={`/images/yunko/ic-menu.png`}
              loading="lazy"
              onClick={() => setIsOpen(true)}
            />

            <img
              className="logo"
              src={`/images/yunko/ic-yunko-logo.png`}
              loading="lazy"
              alt="元辰雲閣"
            />
          </nav>

          {/*側邊抽屜*/}
          <div className={`drawer ${isOpen ? "open" : ""}`}>
            <div className="drawer-left">
              <button className="login-button">登入</button>

              <ul className="menu-list">
                <li>
                  <Link className="nav-link" to="/story">
                    品牌故事
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/personal-chart">
                    個人專屬命盤
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/service">
                    命理服務
                  </Link>
                  <div className="service-submenu">
                    <div className="v-line"></div>
                    <ul className="submenu">
                      <li>
                        <Link className="nav-link" to="/flow-year">
                          流年運勢詳批
                        </Link>
                      </li>
                      <div className="space"></div>
                      <li>
                        <Link className="nav-link" to="/big-flow">
                          十年大運詳批
                        </Link>
                      </li>
                      <div className="space"></div>
                      <li>
                        <Link className="nav-link" to="/love-report">
                          真愛合盤
                        </Link>
                      </li>
                      <div className="space"></div>
                      <li>
                        <Link className="nav-link" to="/friend-report">
                          友情合盤
                        </Link>
                      </li>
                      <div className="space"></div>
                      <li>
                        <Link className="nav-link" to="/name-report">
                          姓名分析測算
                        </Link>
                      </li>
                      <div className="space"></div>
                      <li>
                        <Link className="nav-link" to="/trigrams">
                          奇門遁甲
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <Link className="nav-link" to="/blog">
                    雲閣藏書
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/store">
                    雲上雜貨店
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/teacher">
                    大師諮詢
                  </Link>
                </li>
              </ul>
            </div>

            <div className="drawer-right">
              <i
                className="bi bi-x close-button"
                onClick={() => setIsOpen(false)}
              ></i>
            </div>
          </div>

          {/* 用現代思維看懂命運 */}
          <div className="first-block">
            <div className="display-figure">
              <div className="back-card"></div>

              <img
                src={`/images/yunko/bg-figure-1.jpg`}
                loading="lazy"
                alt="用現代思維看懂命運的規律"
              />
            </div>

            <p className="slogan">
              用現代思維，<br></br>看懂命運的規律。
            </p>

            <hr />

            <p className="sub-slogan">
              結合千年命理經典與現代生活語言，給你最貼近人生的解析
            </p>

            <button>查看命理服務項目</button>
          </div>
          {/* 命理應該被說得更清楚 */}
          <div className="second-block">
            <div className="inner">
              <div className="figure-img">
                <img
                  src={`/images/yunko/bg-figure-2.jpg`}
                  loading="lazy"
                  alt="命理應該被說得更清楚"
                />
              </div>

              <p className="slogan">
                命理應該被說得<br></br>更清楚、更貼近生活
              </p>

              <div className="sub-slogan">
                <div className="v-line"></div>
                <p>
                  我的命理解析講人話，不講艱深術語<br></br>
                  內容落實在感情、職涯、健康、財運各方面<br></br>
                  一步一腳印，從你的命盤給出實際建議
                </p>
              </div>
            </div>
          </div>
          {/* 傳統與我們的差異 */}
          <div className="third-block">
            <p className="slogan">
              不只是看命，<br></br>而是讓你掌握命運的節奏。
            </p>

            <p className="sub-slogan">
              為什麼選擇我們？與傳統命理網站有什麼不同？
            </p>

            <div className="inner">
              <div className="normal">
                <p className="title">傳統命理網站</p>
                <p className="sub-title">使用難懂術語堆疊</p>
                <p className="sub-title">制式分析套模</p>
                <p className="sub-title">命理方式各自分開</p>
              </div>

              <div className="our">
                <div className="our-inner">
                  <p className="title">我們的方式</p>

                  <div className="sub-title">
                    <p className="des">白話命盤解說</p>
                    <img
                      src={`/images/yunko/ic-victory.png`}
                      loading="lazy"
                      alt="勝"
                    />
                  </div>

                  <div className="sub-title">
                    <p className="des">一對一解析與命格差異考量</p>
                    <img
                      src={`/images/yunko/ic-victory.png`}
                      loading="lazy"
                      alt="勝"
                    />
                  </div>

                  <div className="sub-title">
                    <p className="des">結合八字與紫微斗數測算</p>
                    <img
                      src={`/images/yunko/ic-victory.png`}
                      loading="lazy"
                      alt="勝"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 個人專屬命盤 */}
          <div className="forth-block">
            <div className="display-figure">
              <div className="back-card"></div>

              <img
                src={`/images/yunko/bg-figure-3.jpg`}
                loading="lazy"
                alt="用現代思維看懂命運的規律"
              />
            </div>

            <div className="forth-des">
              <p className="slogan">個人專屬命盤</p>

              <p className="small-slogan">從八字與紫薇中看見真實的你</p>

              <p className="des">
                你的出生年、月、日、時，蘊藏了獨一無二的命格結構。這是一份了解自己、理解命運節奏的第一步，也最值得收藏的專屬命理藍圖。
              </p>

              <button>免費測算命盤</button>
            </div>
          </div>
          {/* 所有功能輪播介紹 */}
          <div className="fifth-block">
            <img src={current.image} alt={current.title} loading="lazy" />

            <p className="title">{current.title}</p>
            <p className="small-title">{current.subtitle}</p>
            <p className="sub-title">{current.description}</p>

            <div className="process-bar">
              {serviceCarouselData.map((_, i) => (
                <div
                  key={i}
                  className={`bar-segment ${i === index ? "active" : ""}`}
                />
              ))}
            </div>
            <button>查看更多</button>
          </div>
          {/* 用戶回饋輪播 */}
          <div className="sixth-block">
            <div className="figure-img">
              <img
                src={`/images/yunko/bg-figure-4.jpg`}
                loading="lazy"
                alt="圖片 1"
              />
            </div>

            <div className="sixth-des">
              <p className="slogan">
                數萬人親身體驗，<br></br>命理也可以很清楚！
              </p>

              <p className="customer">{currentCustomer.customer}</p>
              <p className="feedback">{currentCustomer.feedback}</p>

              <div className="process-bar">
                {customerFeedbackData.map((_, i) => (
                  <div
                    key={i}
                    className={`bar-segment ${
                      i === customerIndex ? "active" : ""
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
          {/* 引導獲取專屬命盤 */}
          <div className="seventh-block">
            <p className="title">你的命格藏著什麼樣的關鍵密碼？</p>
            <p className="sub-title">
              輸入生日時間，免費取得你的專屬命盤解析報告
            </p>
          </div>
          {/*元辰雲閣理念*/}
          <div className="eighth-block">
            <div className="outer">
              <div className="inner">
                <div className="display-figure">
                  <div className="back-card"></div>

                  <img
                    src={`/images/yunko/bg-figure-5.jpg`}
                    loading="lazy"
                    alt="用現代思維看懂命運的規律"
                  />
                </div>

                <div className="eighth-des">
                  <p className="title">元辰雲閣的理念</p>

                  <div className="slogan">
                    <div className="v-line"></div>

                    <div className="slogan-des">
                      <p className="main-slogan">
                        「命理不是命運的答案，而是未來人生的提案！」
                      </p>

                      <p className="main-des">
                        元辰雲閣由多年經驗的命理師創立，堅持以誠信、專業與平實價格，提供真正對人生有幫助的命理服務。我們深知傳統命理博大精深，但更相信，命理不該艱澀難懂，而是每個人都能看得懂、用得上的生活智慧。
                      </p>

                      <p className="extra-des">
                        我們的責任，是用現代語言解釋命盤中的訊息，幫你看懂自己的節奏與方向，安心走好每一步人生路。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*隱私政策與聯絡官方*/}
          <footer>
            <div className="logo">
              <img
                src={`/images/yunko/ic-yunko-logo.png`}
                loading="lazy"
                alt="元辰雲閣"
              />
            </div>

            <div className="other-info">
              <a href="">隱私權政策與使用條款</a>

              <div className="space"></div>

              <a href="">聯絡官方Line客服</a>
            </div>

            <p>Copyright © 2025 元辰雲閣</p>
          </footer>
        </div>
      )}
    </div>
  );
};

export default DashboardComponent;
